const registerChecklistDetail = (checklistID) => {
  $(function () {
    $('.citems').sortable({
      stop: function () {
        const itemOrder = $.map($('.citems').children(), (i) => $(i).data('id'));
        $.post(`/checklists/order_items/${checklistID}/`, { item_order: itemOrder });
      }
    });
  });
};

const registerChecklistDetailItemToggle = () => {
  $(function () {
    $('.checklist__todolistitem-togglebutton').click(function() {
      $(this).parents('.checklist__todolistitem').find('i').toggleClass('down').toggleClass('right');
      $(this).parents('.checklist__todolistitem-container').next().toggleClass('hidden');
    });
  });
};
const registerChecklistCheckboxRefresh = () => {
  $(function () {
    $('.checklist__todolistitem-firstcol input[type="checkbox"]').click(function() {
      const href = $(this).data('href');
      location.href = href;
    });
  });
};

const registerChecklistCommentDisable = () => {
  $(function () {
    $('#comment-button').attr('disabled',true);
    $('#comment-body').keyup(function(){
      $('#comment-button').attr('disabled', !($(this).val().length !== 0 && !$(this).hasClass('is_archived')));
    })
  });
};

const registerCinstanceDetail = () => {
  registerChecklistDetailItemToggle();
  registerChecklistCheckboxRefresh();
  registerChecklistCommentDisable();
};

window.registerCinstanceDetail = registerCinstanceDetail;


window.registerChecklistDetail = registerChecklistDetail;


